/* eslint-disable no-extend-native */

declare global {
    interface String {
        isNumber(): boolean;
        capitalize(): string;
        camelize(): string;
    }
    interface Array<T> {
        inColumns(parts: number): T[][];
    }
    interface Window {
        makeid(length: number): string;
    }
}

String.prototype.isNumber = function (): boolean {
    return /^\d+$/.test(String(this));
};

String.prototype.capitalize = function (): string {
    const s = String(this);
    return s.charAt(0).toUpperCase() + s.slice(1);
};

window.makeid = function (length: number): string {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

String.prototype.camelize = function (): string {
    const self = String(this);
    const str = self
        .toLowerCase()
        .trim()
        .split(/[ -_]/g)
        .map((word) => word.replace(word[0], word[0].toString().toUpperCase()))
        .join("");
    return str.replace(str[0], str[0].toLowerCase());
};

Array.prototype.inColumns = function <T>(parts: number): T[][] {
    const result: T[][] = [];
    const chunkSize = Math.ceil(this.length / parts);
    for (let i = 0; i < parts; i++) {
        const start = i * chunkSize;
        const end = start + chunkSize;
        result.push(this.slice(start, end));
    }
    return result;
};

/**
 * Явно заданная функция для капитализации (без прототипов)
 */
export function capitalize(stringEntry: string): string;
export function capitalize(stringEntry: unknown): unknown;
export function capitalize(stringEntry: string | unknown): string | unknown {
    return typeof stringEntry === "string"
        ? stringEntry.charAt(0).toUpperCase() + stringEntry.slice(1)
        : stringEntry;
}
